module.exports = __webpack_public_path__ + "img/ambassadors-page-header.b1ae2b13.svg";